import { render } from "./SessionStart.vue?vue&type=template&id=448beedf&scoped=true"
import script from "./SessionStart.vue?vue&type=script&lang=js"
export * from "./SessionStart.vue?vue&type=script&lang=js"

import "./SessionStart.vue?vue&type=style&index=0&id=448beedf&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-448beedf"

export default script